import { render, staticRenderFns } from "./TSelector.vue?vue&type=template&id=518e6dfc&scoped=true"
import script from "./TSelector.vue?vue&type=script&lang=js"
export * from "./TSelector.vue?vue&type=script&lang=js"
import style0 from "./TSelector.vue?vue&type=style&index=0&id=518e6dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e6dfc",
  null
  
)

export default component.exports